import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FaArrowLeft } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import SupportTicketDetails from '../../components/support/tickets/SupportTicketDetails';
import LoadingSpinner from '../../components/shared/LoadingSpinner';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.75rem;
  background-color: #f0f0f0;
  min-height: 100vh;
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
`;

const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.85rem;
  background: #ffffff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  color: #2d3436;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;
`;

const EmbedUserTicketDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    ticketDetails,
    detailsLoading,
    detailsError,
    fetchTicketDetails,
    fetchUserTickets,
    users,
  } = useApp();

  useEffect(() => {
    if (id) {
      fetchTicketDetails(id);
    }
  }, [id, fetchTicketDetails]);

  const handleTicketUpdate = async () => {
    if (id) await fetchTicketDetails(id);
  };

  const handleListUpdate = () => {
    fetchUserTickets?.();
  };

  const handleResetSelection = () => {
    navigate('/embed/user/tickets');
  };

  if (detailsLoading && !ticketDetails) {
    return (
      <PageContainer>
        <LoadingSpinner />
      </PageContainer>
    );
  }

  if (detailsError && !ticketDetails) {
    return (
      <PageContainer>
        <BackButton type="button" onClick={() => navigate('/embed/user/tickets')}>
          <FaArrowLeft /> Voltar
        </BackButton>
        <p style={{ color: '#d63031' }}>{detailsError}</p>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <BackButton type="button" onClick={() => navigate('/embed/user/tickets')}>
        <FaArrowLeft /> Voltar à lista
      </BackButton>
      <SupportTicketDetails
        ticket={ticketDetails}
        users={users || []}
        onTicketUpdate={handleTicketUpdate}
        onListUpdate={handleListUpdate}
        onResetSelection={handleResetSelection}
      />
    </PageContainer>
  );
};

export default EmbedUserTicketDetailPage;
